module.exports = __webpack_public_path__ + "static/img/5bg_13.ac93df9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_13.png
// module id = 726
// module chunks = 1